import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object
  ) { }

  read(name: String): string | null {

    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }

    // The document.cookie contains only unexpired cookies - no need to check expiry
    const regex = new RegExp(`(?:^|;)\\s*${name}=([^;]*)`);
    const match = this.document.cookie.match(regex);
    return match ? decodeURIComponent(match[1]) : null;
  }
}
